<template>
<div class="absolute bottom-0 left-0 right-0 bg-orange-600 p-3" @click='clear'>
  <slot name='default' />
</div>
</template>
<script>
export default {
  props:{
    value: {
      type: Boolean,
      required: true
    }
  },
  components:{
  },
  data() {
    return {
    }
  },
  methods:{
    clear() {
      this.$emit('input', false);
    }
  },
  mounted() {
    this.timer = setTimeout( () => {
      this.clear();
    }, 2500);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
}
</script>
